<template>
  <form class="synchro-settings__form" @submit.prevent="submit()">
    <div class="mt-2 popup__section column">
      <radio-button
        v-slot="{ selected, label }"
        :value="data.sync"
        style="font-weight: 600"
        :label="$t('labels.activateSynchronization')"
        :data="true"
        class="radiobutton_top"
        @update:value="data.sync = $event"
      >
        <div>
          <span
            class="radiobutton__label"
            :class="{ 'is-selected': selected }"
            >{{ label }}</span
          >
          <p class="synchro-settings__description">
            {{ $t("texts.synchronizationActiveDescription") }}
          </p>
        </div>
      </radio-button>
      <radio-button
        v-slot="{ selected, label }"
        :value="data.sync"
        style="font-weight: 600"
        :label="$t('labels.deactivateSynchronization')"
        :data="false"
        class="radiobutton_top mt-4"
        @update:value="data.sync = $event"
      >
        <div>
          <span
            class="radiobutton__label"
            :class="{ 'is-selected': selected }"
            >{{ label }}</span
          >
          <p class="synchro-settings__description">
            {{ $t("texts.synchronizationInactiveDescription") }}
          </p>
        </div>
      </radio-button>
    </div>

    <div class="popup__buttons">
      <button class="button" type="submit" :disabled="syncEnabled === data.sync">
        <template v-if="syncEnabled == null">
          {{ $t("labels.confirmChoice") }}
        </template>
        <template v-else-if="syncEnabled === data.sync">
          {{ $t("labels.saved") }}
        </template>
        <template v-else-if="syncEnabled !== data.sync">
          {{ $t("labels.save") }}
        </template>
      </button>
    </div>
  </form>
</template>

<script setup lang="ts">
import { reactive } from "vue";
import RadioButton from "@core/input/RadioButton.vue";

import { useUser } from "@/api/user.store";

const emit = defineEmits<{
  (event: "submit"): void;
}>();

const { syncEnabled } = useUser();

const data = reactive({
  sync: syncEnabled.value
});

function saveSetting() {
  syncEnabled.value = data.sync;
}
function submit() {
  saveSetting();
  emit("submit");
}
</script>

<style lang="scss">
.synchro-settings {
  &__form {
    max-width: 50rem;
  }
  &__description {
    // padding-left: 2.25rem;
    margin-top: 0.25rem;
    margin-bottom: 0;
    font-weight: 400;
    font-size: 1rem;
  }
}
</style>
